import { boolean, object, string } from 'yup'
const SignInFormCheck = object().shape({
  email: string(),
  password: string()
    .required('Please enter  password.')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
 'Password must contain min. 8 and max. 15 characters, one uppercase, one lowercase, one number, and one special character ( $ ! @ ... )',    ),
  contactNumber: string()
    .required('Please enter  contact number.')
    .min(9, 'Please enter valid number'),
  priceWithVat: boolean()
    .nullable()
    .required('Please select how prices should be imported | اختر طريقة استيراد الأسعار'),
})

export default SignInFormCheck
